import { FiArchive, FiChevronLeft, FiLock, FiUnlock } from 'react-icons/fi';

export function TopBar({
  title,
  canEdit,
  showArchived,
  onBack,
  onToggleArchived,
  onToggleLock
}: {
  title: string;
  canEdit: boolean;
  showArchived: boolean;
  onBack: () => void;
  onToggleArchived: () => void;
  onToggleLock: () => void;
}) {
  return (
    <header className="topbar glass" role="region" aria-label="Events toolbar">
      <button className="btn icon" type="button" aria-label="Back" onClick={onBack}>
        <FiChevronLeft />
      </button>

      <h2 id="events-title">{title}</h2>

      <div className="right-actions">
        <button
          className="btn icon"
          type="button"
          aria-pressed={showArchived}
          aria-label={showArchived ? 'Hide archived' : 'View archived'}
          title={showArchived ? 'Hide archived' : 'View archived'}
          onClick={onToggleArchived}
        >
          <FiArchive />
        </button>
        <button
          className="btn icon"
          type="button"
          aria-pressed={canEdit}
          aria-label={canEdit ? 'Lock editing' : 'Unlock to edit'}
          onClick={onToggleLock}
        >
          {canEdit ? <FiLock /> : <FiUnlock />}
        </button>
      </div>
    </header>
  );
}
